import { TreeNode } from "@core/services/tree-builder.service";
import { obtenerPathRaiz } from "../modulo-ruta.utils";

/** Grupos (tipo M) que contienen la pantalla de la URL, del más externo al más interno. */
export function obtenerRamaActiva(nodos: TreeNode[], url: string): TreeNode[] {
  const path = obtenerPathRaiz(url);
  if (!path) return [];

  for (const nodo of nodos) {
    if (nodo.tipo !== "M") continue;
    if (nodo.children?.some((hijo) => hijo.tipo !== "M" && hijo.path === path)) return [nodo];

    const ramaHija = obtenerRamaActiva(nodo.children ?? [], url);
    if (ramaHija.length) return [nodo, ...ramaHija];
  }
  return [];
}
